/**
 * Botón "Contenus" — abre el visor de contenidos interactivos Nomade
 * (episodios Genially de la Alianza Francesa). Hermano visual de InfoButton
 * y SettingsButton; reusa .info-button para el estilo base.
 */

import './InfoButton.css'; // reusa .info-button para el estilo base

interface ContentsButtonProps {
  onClick: () => void;
  isOpen?: boolean;
  /** Espacio de trabajo: el botón no se oculta al abrir, queda marcado y alterna. */
  active?: boolean;
  /** Modo profesor (aide-prof): etiqueta en francés. Por defecto español. */
  aideProf?: boolean;
}

export function ContentsButton({ onClick, isOpen = false, active, aideProf = false }: ContentsButtonProps) {
  return (
    <button
      type="button"
      className={`info-button contents-button ${isOpen ? 'hidden' : ''} ${active ? 'is-active' : ''}`}
      onClick={onClick}
      aria-pressed={active}
      aria-label={aideProf ? 'Contenus du cours' : 'Contenidos del curso'}
      title={aideProf ? 'Contenus du cours' : 'Contenidos del curso (Nomade)'}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
        <polygon points="11 7 15 9.5 11 12" fill="currentColor" stroke="none" />
      </svg>
    </button>
  );
}
